import script from "./MainPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./MainPage.vue?vue&type=script&setup=true&lang=ts"

import "./MainPage.vue?vue&type=style&index=0&id=5698f04b&lang=css"

const __exports__ = script;

export default __exports__